import { DropdownBasic } from "./DropdownBasic";
import { DropdownOption } from "./DropdownOption";

const Dropdown = DropdownBasic;
Dropdown.Option = DropdownOption;

export {
    Dropdown
};